export enum CRON_JOBS_JOB_TYPES {
  ACHIEVEMENTS = 'A',
  TARGETS = 'T',
  PAYOUTS = 'P',
}

export enum CRON_JOBS_JOB_HISTORY_TYPES {
  PAUSED = 'PAUSED',
  RESUMED = 'RESUMED',
  COMPLETED = 'COMPLETED',
  STOPPED = 'STOPPED',
  FAILED = 'FAILED',
  STARTED = 'STARTED',
  CANCELLED = 'CANCELLED',
  P_COMPLETED = 'P_COMPLETED',
}
